export const SEARCH_INPUT_TYPES = {
  WEBSITE: 'website',
  KEYWORD: 'keyword',
};

export const SEARCH_INPUT_TITLES = {
  [SEARCH_INPUT_TYPES.WEBSITE]: _TL_('Scan your website for keywords'),
  [SEARCH_INPUT_TYPES.KEYWORD]: _TL_('Add your products or services'),
};

export const SEARCH_INPUT_PLACEHOLDERS = {
  [SEARCH_INPUT_TYPES.WEBSITE]: _TL_("Enter your website's URL"),
  [SEARCH_INPUT_TYPES.KEYWORD]: _TL_('Enter your products or services'),
};
